import { Switch, Route } from 'react-router-dom';
import Sport from '../screens/sport/index';
import Home from '../screens/Home';
import Arrienda from '../screens/sport/arrienda/filter';
import Filter from '../screens/sport/arrienda/reservar/index';
import Clubes from '../screens/sport/arrienda/clubes/index';
import Pago from '../screens/sport/arrienda/pago/index';
import Confirmado from '../screens/sport/arrienda/pago/confirmado/index';
import Integrar from '../screens/sport/integrar/filter';
import Partidos from '../screens/sport/integrar/partidos/index';
import Inscription from '../screens/sport/integrar/unirse/index';
import RegistrationConfirmed from '../screens/sport/integrar/unirse/confirmada/index';
import Profile from '../screens/Profile';
import PagoIntegra from '../screens/sport/integrar/pago/index';
import TermsConditions from '../screens/TermsConditions';
import Defy from '../screens/sport/defy/filter';
import FilterDefy from '../screens/sport/defy/create/index';
import TeamsDefy from '../screens/sport/defy/teams/index';
import PositionsDefy from '../screens/sport/defy/positions/index';
import PagoDefy from '../screens/sport/defy/pago/index';
import ConfirmDefy from '../screens/sport/defy/create/confirm/index';
import FilterReservar from '../screens/sport/defy/reservar/index';
import ClubesDefy from '../screens/sport/defy/clubes/index';
import Challenge from '../screens/sport/defy/challenge/index';
import ChallengeResponse from '../screens/sport/defy/challenge/response';
import ChallengeConfirm from '../screens/sport/defy/challenge/confirm/index';
import Faq from '../screens/Faq';
import Success from '../screens/sport/arrienda/pago/ticketplus/success';
import Fail from '../screens/sport/arrienda/pago/ticketplus/fail';

const Authenticated = (): JSX.Element => {
    return (
        <Switch>
            <Route path="/" exact component={Home} />
            <Route path="/perfil" exact component={Profile} />
            <Route path="/terminos-condiciones" exact component={TermsConditions} />
            <Route path="/preguntas-frecuentes" exact component={Faq} />
            {/*Futbol */}
            <Route path="/futbol" exact component={Sport} />
            <Route path="/futbol/arrienda" exact component={Arrienda} />
            <Route path="/futbol/arrienda/reservar/filter" exact component={Filter} />
            <Route path="/futbol/arrienda/clubes/filter" exact component={Clubes} />
            <Route path="/futbol/arrienda/pago/filter" exact component={Pago} />
            <Route path="/futbol/arrienda/pago/confirmado" exact component={Confirmado} />
            <Route path="/futbol/arrienda/pago/confirmar" exact component={Success} />
            <Route path="/futbol/arrienda/pago/fallo" exact component={Fail} />
            <Route path="/futbol/integrar" exact component={Integrar} />
            <Route path="/futbol/integrar/partidos/filter" exact component={Partidos} />
            <Route path="/futbol/integrar/unirse/filter" exact component={Inscription} />
            <Route path="/futbol/integrar/unirse/confirmar/filter" exact component={RegistrationConfirmed} />
            <Route path="/futbol/integrar/pago/filter" exact component={PagoIntegra} />
            <Route path="/futbol/desafiar" exact component={Defy} />
            <Route path="/futbol/desafiar/equipo/filter" exact component={Challenge} />
            <Route path="/futbol/desafiar/equipo/confirmar/filter" exact component={ChallengeConfirm} />
            <Route path="/futbol/desafiar/equipo/responder/filter" exact component={ChallengeResponse} />
            <Route path="/futbol/desafiar/equipos/crear" exact component={FilterDefy} />
            <Route path="/futbol/desafiar/equipos/filter" exact component={TeamsDefy} />
            <Route path="/futbol/desafiar/equipos/posiciones/filter" exact component={PositionsDefy} />
            <Route path="/futbol/desafiar/reservar/filter" exact component={FilterReservar} />
            <Route path="/futbol/desafiar/clubes/filter" exact component={ClubesDefy} />
            <Route path="/futbol/desafiar/pago/filter" exact component={PagoDefy} />
            <Route path="/futbol/desafiar/pago/confirmado" exact component={Confirmado} />
            <Route path="/futbol/desafiar/pago/fallo" exact component={Fail} />
            <Route path="/futbol/desafiar/equipos/crear/confirmar/filter" exact component={ConfirmDefy} />
            {/*Padel */}
            <Route path="/padel" exact component={Sport} />
            <Route path="/padel/arrienda" exact component={Arrienda} />
            <Route path="/padel/arrienda/reservar/filter" exact component={Filter} />
            <Route path="/padel/arrienda/clubes/filter" exact component={Clubes} />
            <Route path="/padel/arrienda/pago/filter" exact component={Pago} />
            <Route path="/padel/arrienda/pago/confirmado/filter" exact component={Confirmado} />
            <Route path="/padel/integrar" exact component={Integrar} />
            <Route path="/padel/integrar/partidos/filter" exact component={Partidos} />
            <Route path="/padel/integrar/unirse/filter" exact component={Inscription} />
            <Route path="/padel/integrar/unirse/confirmar/filter" exact component={RegistrationConfirmed} />
            <Route path="/padel/integrar/pago/filter" exact component={PagoIntegra} />
            <Route path="/padel/desafiar" exact component={Defy} />
            <Route path="/padel/desafiar/equipo/filter" exact component={Challenge} />
            <Route path="/padel/desafiar/equipo/confirmar/filter" exact component={ChallengeConfirm} />
            <Route path="/padel/desafiar/equipo/responder/filter" exact component={ChallengeResponse} />
            <Route path="/padel/desafiar/equipos/crear" exact component={FilterDefy} />
            <Route path="/padel/desafiar/equipos/filter" exact component={TeamsDefy} />
            <Route path="/padel/desafiar/equipos/posiciones/filter" exact component={PositionsDefy} />
            <Route path="/padel/desafiar/reservar/filter" exact component={FilterReservar} />
            <Route path="/padel/desafiar/clubes/filter" exact component={ClubesDefy} />
            <Route path="/padel/desafiar/pago/filter" exact component={PagoDefy} />
            <Route path="/padel/desafiar/equipos/crear/confirmar/filter" exact component={ConfirmDefy} />
            {/*Tenis */}
            <Route path="/tenis" exact component={Sport} />
            <Route path="/tenis/arrienda" exact component={Arrienda} />
            <Route path="/tenis/arrienda/reservar/filter" exact component={Filter} />
            <Route path="/tenis/arrienda/clubes/filter" exact component={Clubes} />
            <Route path="/tenis/arrienda/pago/filter" exact component={Pago} />
            <Route path="/tenis/arrienda/pago/confirmado/filter" exact component={Confirmado} />
            <Route path="/tenis/integrar" exact component={Integrar} />
            <Route path="/tenis/integrar/partidos/filter" exact component={Partidos} />
            <Route path="/tenis/integrar/unirse/filter" exact component={Inscription} />
            <Route path="/tenis/integrar/unirse/confirmar/filter" exact component={RegistrationConfirmed} />
            <Route path="/tenis/integrar/pago/filter" exact component={PagoIntegra} />
            <Route path="/tenis/desafiar" exact component={Defy} />
            <Route path="/tenis/desafiar/equipo/filter" exact component={Challenge} />
            <Route path="/tenis/desafiar/equipo/confirmar/filter" exact component={ChallengeConfirm} />
            <Route path="/tenis/desafiar/equipo/responder/filter" exact component={ChallengeResponse} />
            <Route path="/tenis/desafiar/equipos/crear" exact component={FilterDefy} />
            <Route path="/tenis/desafiar/equipos/filter" exact component={TeamsDefy} />
            <Route path="/tenis/desafiar/equipos/posiciones/filter" exact component={PositionsDefy} />
            <Route path="/tenis/desafiar/reservar/filter" exact component={FilterReservar} />
            <Route path="/tenis/desafiar/clubes/filter" exact component={ClubesDefy} />
            <Route path="/tenis/desafiar/pago/filter" exact component={PagoDefy} />
            <Route path="/tenis/desafiar/equipos/crear/confirmar/filter" exact component={ConfirmDefy} />
            {/*Basquetbol */}
            <Route path="/basquetbol" exact component={Sport} />
            <Route path="/basquetbol/arrienda" exact component={Arrienda} />
            <Route path="/basquetbol/arrienda/reservar/filter" exact component={Filter} />
            <Route path="/basquetbol/arrienda/clubes/filter" exact component={Clubes} />
            <Route path="/basquetbol/arrienda/pago/filter" exact component={Pago} />
            <Route path="/basquetbol/arrienda/pago/confirmado/filter" exact component={Confirmado} />
            <Route path="/basquetbol/integrar" exact component={Integrar} />
            <Route path="/basquetbol/integrar/partidos/filter" exact component={Partidos} />
            <Route path="/basquetbol/integrar/unirse/filter" exact component={Inscription} />
            <Route path="/basquetbol/integrar/unirse/confirmar/filter" exact component={RegistrationConfirmed} />
            <Route path="/basquetbol/integrar/pago/filter" exact component={PagoIntegra} />
            <Route path="/basquetbol/desafiar" exact component={Defy} />
            <Route path="/basquetbol/desafiar/equipo/filter" exact component={Challenge} />
            <Route path="/basquetbol/desafiar/equipo/confirmar/filter" exact component={ChallengeConfirm} />
            <Route path="/basquetbol/desafiar/equipo/responder/filter" exact component={ChallengeResponse} />
            <Route path="/basquetbol/desafiar/equipos/crear" exact component={FilterDefy} />
            <Route path="/basquetbol/desafiar/equipos/filter" exact component={TeamsDefy} />
            <Route path="/basquetbol/desafiar/equipos/posiciones/filter" exact component={PositionsDefy} />
            <Route path="/basquetbol/desafiar/reservar/filter" exact component={FilterReservar} />
            <Route path="/basquetbol/desafiar/clubes/filter" exact component={ClubesDefy} />
            <Route path="/basquetbol/desafiar/pago/filter" exact component={PagoDefy} />
            <Route path="/basquetbol/desafiar/equipos/crear/confirmar/filter" exact component={ConfirmDefy} />
            <Route path="/" component={Home} />
        </Switch>
    );
};

export default Authenticated;
